document.addEventListener('DOMContentLoaded', () => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.summary-content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
        setTimeout(() => {
             document.querySelectorAll('details').forEach((accordion) => {
          if (accordion !== this.el && accordion.open && !accordion.closest('.pdp-details-container')) {
              accordion.open = false;
          }
        }, 1000)})
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }
  document.querySelectorAll('.hero-text-media-component details').forEach((el) => {
    new Accordion(el);
  });

  document.querySelectorAll('.pdp-details-container details').forEach((el) => {
    new Accordion(el);
  });

  const summaryContents = document.querySelectorAll('.summary-content');

  summaryContents.forEach((summaryContent) => {
    const ingredients = summaryContent.querySelector('.ingredients-list');
    if (ingredients) {
      if (!summaryContent.querySelector('#toggle-ingredients')) {
        const toggleLink = document.createElement('a');
        toggleLink.href = '#';
        toggleLink.id = 'toggle-ingredients';
        toggleLink.textContent = 'SHOW FULL INGREDIENT LIST';
        toggleLink.style.cursor = 'pointer';

        summaryContent.insertBefore(toggleLink, ingredients);

        toggleLink.addEventListener('click', function (event) {
          event.preventDefault();

          if (ingredients.classList.contains('expanded')) {
            ingredients.classList.remove('expanded');
            toggleLink.textContent = 'SHOW FULL INGREDIENT LIST';
          } else {
            ingredients.classList.add('expanded');
            toggleLink.textContent = 'HIDE FULL INGREDIENT LIST';
          }
        });
      }
    }
  });

  const ingredientNames = document.querySelectorAll(".ingredient_name");

  ingredientNames.forEach((ingredient) => {
    ingredient.addEventListener("click", function () {
      const index = this.classList[1].split("-")[1];
      const descriptionElement = document.querySelector(`.ingredient_description.description-${index}`);

      if (descriptionElement) {
        const descriptionText = descriptionElement.textContent || "Description not available";
        const ingredientName = this.textContent.replace(/,\s*$/, "");
        showModal(ingredientName, descriptionText);
      }
    });
  });

  function showModal(title, description) {
    let modal = document.getElementById("ingredientModal");
    let overlay = document.getElementById("modalOverlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "modalOverlay";

      overlay.addEventListener("click", function () {
        modal.style.display = "none";
        overlay.style.display = "none";
        document.body.style.overflow = "";
      });

      document.body.appendChild(overlay);
    }

    if (!modal) {
      modal = document.createElement("div");
      modal.id = "ingredientModal";
      document.body.appendChild(modal);
    }

    modal.innerHTML = `<h3 class="popup-title">${title}</h3><p class="popup-description">${description}</p>`;

    const closeButton = document.createElement("button");
    closeButton.innerHTML = `
            <svg width="40" height="40" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="11.24" y1="33.88" x2="33.88" y2="11.24" stroke="#1B365D" stroke-width="0.82"/>
                <line x1="10.62" y1="11.24" x2="32.38" y2="33.88" stroke="#1B365D" stroke-width="0.82"/>
            </svg>`;

    closeButton.addEventListener("click", function () {
      modal.style.display = "none";
      overlay.style.display = "none";
      document.body.style.overflow = "";
    });

    modal.appendChild(closeButton);

    modal.style.display = "block";
    overlay.style.display = "block";
    document.body.style.overflow = "hidden";
  }
})